var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", {
        attrs: {
          items: [{ text: "Users", path: { name: "admin-users" } }],
          name: _vm.fullName,
          "no-title": "",
        },
      }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { lg: "4", md: "5" } },
            [
              _c(
                "admin-panel",
                {
                  attrs: { "second-body": "", "with-footer": "" },
                  scopedSlots: _vm._u([
                    {
                      key: "second-body",
                      fn: function () {
                        return [
                          _c("small", { staticClass: "text-muted" }, [
                            _vm._v("Email address"),
                          ]),
                          _vm._v(" "),
                          _c("h6", [_vm._v(_vm._s(_vm.user.email))]),
                          _vm._v(" "),
                          _vm.user.phone
                            ? [
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v("Phone"),
                                ]),
                                _vm._v(" "),
                                _c("h6", [_vm._v(_vm._s(_vm.user.phone))]),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.user.date_birth
                            ? [
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v("Date Birth"),
                                ]),
                                _vm._v(" "),
                                _c("h6", [_vm._v(_vm._s(_vm.user.date_birth))]),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c("small", { staticClass: "text-muted" }, [
                            _vm._v("Registered"),
                          ]),
                          _vm._v(" "),
                          _c("h6", [_vm._v(_vm._s(_vm.registeredOn))]),
                          _vm._v(" "),
                          !_vm.user.is_active
                            ? [
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v("Deactivated"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "h6",
                                  [
                                    _vm._v(
                                      "\n              on " +
                                        _vm._s(_vm.deactivatedOn) +
                                        "\n              "
                                    ),
                                    _vm.user.deactivated_by
                                      ? [
                                          _c("br"),
                                          _vm._v("by\n                "),
                                          _c(
                                            "b-link",
                                            {
                                              attrs: {
                                                to: {
                                                  name: "admin-user",
                                                  params: {
                                                    id: _vm.user.deactivated_by.id.toString(),
                                                  },
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.user.deactivated_by.name
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "text-center mt-n1" },
                            [
                              _c(
                                "no-permission-wrapper",
                                { attrs: { show: !_vm.canUpdateUsers } },
                                [
                                  _vm.user.is_active
                                    ? _c(
                                        "b-btn",
                                        {
                                          staticClass: "mt-1",
                                          attrs: {
                                            variant: "danger",
                                            disabled: !_vm.canUpdateUsers,
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.deactivateUser.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("Deactivate User")]
                                      )
                                    : _c(
                                        "b-btn",
                                        {
                                          staticClass: "mt-1",
                                          attrs: {
                                            variant: "success",
                                            disabled: !_vm.canUpdateUsers,
                                          },
                                          on: { click: _vm.activateUser },
                                        },
                                        [_vm._v("Reactivate User")]
                                      ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-btn",
                                {
                                  staticClass: "mt-1",
                                  attrs: { variant: "warning" },
                                  on: { click: _vm.sendPasswordReset },
                                },
                                [_vm._v("Send Password Reset Link")]
                              ),
                              _vm._v(" "),
                              _c(
                                "no-permission-wrapper",
                                { attrs: { show: !_vm.canLoginAsUser } },
                                [
                                  _c(
                                    "b-btn",
                                    {
                                      staticClass: "mt-1",
                                      attrs: {
                                        variant: "secondary",
                                        disabled: !_vm.canLoginAsUser,
                                      },
                                      on: { click: _vm.showAuthToken },
                                    },
                                    [_vm._v("Redeem User Auth Token")]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "no-permission-wrapper",
                                { attrs: { show: !_vm.canLoginAsUser } },
                                [
                                  _c(
                                    "b-btn",
                                    {
                                      staticClass: "mt-1",
                                      attrs: {
                                        variant: "primary",
                                        disabled: !_vm.canLoginAsUser,
                                      },
                                      on: { click: _vm.confirmLoginAsUser },
                                    },
                                    [_vm._v("Login as User")]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.user.role && _vm.user.role.code !== "admin"
                                ? _c(
                                    "no-permission-wrapper",
                                    { attrs: { show: _vm.canHijackUsers } },
                                    [
                                      _c(
                                        "b-btn",
                                        {
                                          staticClass: "mt-1",
                                          attrs: {
                                            variant: "primary",
                                            disabled: !_vm.canHijackUsers,
                                          },
                                          on: { click: _vm.confirmHijackUser },
                                        },
                                        [_vm._v("Hijack User")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c(
                    "div",
                    { staticClass: "mt-3 text-center" },
                    [
                      _c("b-avatar", {
                        attrs: {
                          variant: "primary",
                          src: _vm.user.avatar_url,
                          text: _vm.avatarLetters,
                          size: "150",
                        },
                      }),
                      _vm._v(" "),
                      _c("h4", { staticClass: "card-title mt-3" }, [
                        _vm._v(_vm._s(_vm.fullName)),
                      ]),
                      _vm._v(" "),
                      _vm.user.position
                        ? _c("h6", { staticClass: "card-subtitle" }, [
                            _vm._v(_vm._s(_vm.user.position)),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.user.company
                        ? _c(
                            "h6",
                            { staticClass: "card-subtitle" },
                            [
                              _c(
                                "b-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "admin-company",
                                      params: {
                                        id: _vm.user.company.id.toString(),
                                      },
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.user.company.name))]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.user.is_active
                        ? _c("b-badge", { attrs: { variant: "success" } }, [
                            _vm._v("Active User"),
                          ])
                        : _c("b-badge", { attrs: { variant: "danger" } }, [
                            _vm._v("Inactive User"),
                          ]),
                      _vm._v(" "),
                      _vm.user.company &&
                      _vm.user.company.status.code !== "active"
                        ? _c(
                            "b-badge",
                            {
                              staticClass: "mt-1",
                              attrs: { variant: "danger" },
                            },
                            [
                              _vm._v(
                                "\n            Company Status: " +
                                  _vm._s(_vm.user.company.status.name) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { lg: "8", md: "7" } },
            [
              _c(
                "admin-panel",
                { attrs: { "sub-title": "Edit User Profile" } },
                [
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.submitForm.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "First Name" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      type: "text",
                                      state: _vm.fieldValid("first_name"),
                                      disabled: !_vm.canUpdateUsers,
                                    },
                                    model: {
                                      value: _vm.formData.first_name,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "first_name",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "formData.first_name",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-invalid-feedback",
                                    {
                                      attrs: {
                                        state: _vm.fieldValid("first_name"),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.formValidation.first_name
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Last Name" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      type: "text",
                                      state: _vm.fieldValid("last_name"),
                                      disabled: !_vm.canUpdateUsers,
                                    },
                                    model: {
                                      value: _vm.formData.last_name,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "last_name",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "formData.last_name",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-invalid-feedback",
                                    {
                                      attrs: {
                                        state: _vm.fieldValid("last_name"),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.formValidation.last_name) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Login" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      type: "text",
                                      state: _vm.fieldValid("login"),
                                      disabled: !_vm.canUpdateUsers,
                                    },
                                    model: {
                                      value: _vm.formData.login,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "login",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "formData.login",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-invalid-feedback",
                                    {
                                      attrs: { state: _vm.fieldValid("login") },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.formValidation.login) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Email" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      type: "text",
                                      state: _vm.fieldValid("email"),
                                      disabled: !_vm.canUpdateUsers,
                                    },
                                    model: {
                                      value: _vm.formData.email,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "email",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "formData.email",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-invalid-feedback",
                                    {
                                      attrs: { state: _vm.fieldValid("email") },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.formValidation.email) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        { attrs: { label: "Role" } },
                        [
                          _vm.formData.role === "admin" && !_vm.canCreateAdmins
                            ? _c("b-form-input", {
                                attrs: {
                                  value: _vm.formData.role,
                                  disabled: "",
                                },
                              })
                            : _c("b-form-select", {
                                attrs: {
                                  options: _vm.rolesOptions,
                                  state: _vm.fieldValid("role"),
                                  disabled: !_vm.canUpdateUsers,
                                },
                                model: {
                                  value: _vm.formData.role,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "role",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "formData.role",
                                },
                              }),
                          _vm._v(" "),
                          _c(
                            "b-form-invalid-feedback",
                            { attrs: { state: _vm.fieldValid("role") } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.formValidation.role) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("transition", { attrs: { name: "slide" } }, [
                        _vm.formData.role === "admin"
                          ? _c(
                              "div",
                              [
                                _c(
                                  "b-form-group",
                                  { attrs: { label: "Admin Notifications" } },
                                  _vm._l(
                                    _vm.adminNotificationClasses,
                                    function (nClass, key) {
                                      return _c(
                                        "div",
                                        { key: key },
                                        [
                                          _c(
                                            "b-form-checkbox",
                                            {
                                              key: key,
                                              attrs: {
                                                disabled: !_vm.canUpdateUsers,
                                              },
                                              model: {
                                                value:
                                                  _vm.formData.notifications[
                                                    nClass.class
                                                  ],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.formData.notifications,
                                                    nClass.class,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formData.notifications[nClass.class]",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(nClass.name) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              [
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { md: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          { attrs: { label: "Company" } },
                                          [
                                            _c("b-form-select", {
                                              attrs: {
                                                options: _vm.companies,
                                                state:
                                                  _vm.fieldValid("company"),
                                                disabled: !_vm.canUpdateUsers,
                                              },
                                              model: {
                                                value: _vm.formData.company,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.formData,
                                                    "company",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression: "formData.company",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-invalid-feedback",
                                              {
                                                attrs: {
                                                  state:
                                                    _vm.fieldValid("company"),
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.formValidation.company
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { md: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          { attrs: { label: "User License" } },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                type: "text",
                                                state:
                                                  _vm.fieldValid(
                                                    "user_license"
                                                  ),
                                                disabled: !_vm.canUpdateUsers,
                                              },
                                              model: {
                                                value:
                                                  _vm.formData.user_license,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.formData,
                                                    "user_license",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression:
                                                  "formData.user_license",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-invalid-feedback",
                                              {
                                                attrs: {
                                                  state:
                                                    _vm.fieldValid(
                                                      "user_license"
                                                    ),
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.formValidation
                                                        .user_license
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "mb-1 d-inline-block font-italic",
                                  },
                                  [
                                    _vm._v(
                                      "Leave METRC API Key empty if you don't want to update it"
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  { attrs: { label: "METRC API Key" } },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        type: "text",
                                        state: _vm.fieldValid("metrc_api_key"),
                                        disabled: !_vm.canUpdateUsers,
                                      },
                                      model: {
                                        value: _vm.formData.metrc_api_key,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "metrc_api_key",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "formData.metrc_api_key",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-invalid-feedback",
                                      {
                                        attrs: {
                                          state:
                                            _vm.fieldValid("metrc_api_key"),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.formValidation.metrc_api_key
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "mb-1 d-inline-block font-italic" },
                        [
                          _vm._v(
                            "Leave password fields empty if you don't want to update current password"
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "New Password" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      type: "text",
                                      state: _vm.fieldValid("password"),
                                      disabled: !_vm.canUpdateUsers,
                                    },
                                    model: {
                                      value: _vm.formData.password,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "password",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "formData.password",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-invalid-feedback",
                                    {
                                      attrs: {
                                        state: _vm.fieldValid("password"),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.formValidation.password) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Confirm New Password" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      type: "text",
                                      disabled: !_vm.canUpdateUsers,
                                    },
                                    model: {
                                      value: _vm.formData.password_confirmation,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "password_confirmation",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression:
                                        "formData.password_confirmation",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "no-permission-wrapper",
                        { attrs: { show: !_vm.canUpdateUsers } },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                type: "submit",
                                variant: "primary",
                                disabled:
                                  !_vm.canUpdateUsers ||
                                  _vm.formState.processing,
                              },
                            },
                            [
                              _vm._v(
                                "\n              Update user Profile\n              "
                              ),
                              _vm.formState.processing
                                ? _c("b-spinner", {
                                    staticClass: "ml-1",
                                    attrs: { small: "" },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.user.role &&
          _vm.user.role.code === "admin" &&
          _vm.currentUserIsSuperAdmin
            ? _c(
                "b-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "admin-panel",
                    { attrs: { "sub-title": "Admin Access" } },
                    [
                      _c(
                        "b-form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.saveAdminAccess.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c(
                            "b-form-group",
                            { attrs: { label: "Is SuperAdmin?" } },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: {
                                    state: _vm.fieldValid(
                                      "is_super_admin",
                                      true
                                    ),
                                  },
                                  model: {
                                    value:
                                      _vm.adminAccessFormData.is_super_admin,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.adminAccessFormData,
                                        "is_super_admin",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "adminAccessFormData.is_super_admin",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              Make this admin a super admin with all permissions\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-invalid-feedback",
                                {
                                  attrs: {
                                    state: _vm.fieldValid(
                                      "is_super_admin",
                                      true
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.adminAccessFormValidation
                                          .is_super_admin
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.adminAccessFormData.is_super_admin
                            ? _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "6" } },
                                    [
                                      _c("span", { staticClass: "font-bold" }, [
                                        _vm._v("Available Permissions"),
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.availableAdminPermissions,
                                        function (permissionsGroup, key) {
                                          return _c(
                                            "div",
                                            {
                                              key: key,
                                              staticClass:
                                                "permission-group my-2",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "font-medium text-uppercase d-flex items-center justify-content-between cursor-pointer permission-group-header",
                                                  on: {
                                                    click: () =>
                                                      _vm.togglePermissionGroup(
                                                        "available",
                                                        permissionsGroup.group
                                                      ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        permissionsGroup.group.replaceAll(
                                                          "_",
                                                          " "
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  typeof _vm
                                                    .visiblePermissionGroups
                                                    .available[
                                                    permissionsGroup.group
                                                  ] !== "undefined"
                                                    ? _c("b-icon-chevron-up")
                                                    : _c("b-icon-chevron-down"),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-collapse",
                                                {
                                                  attrs: {
                                                    visible:
                                                      typeof _vm
                                                        .visiblePermissionGroups
                                                        .available[
                                                        permissionsGroup.group
                                                      ] !== "undefined",
                                                  },
                                                },
                                                _vm._l(
                                                  permissionsGroup.permissions,
                                                  function (permission, index) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: index,
                                                        staticClass: "pt-2",
                                                      },
                                                      [
                                                        _c(
                                                          "b-input-group",
                                                          {
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "append",
                                                                  fn: function () {
                                                                    return [
                                                                      _c(
                                                                        "b-button",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              variant:
                                                                                "success",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.addAdminPermission(
                                                                                  permission
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Add"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                  proxy: true,
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("b-input", {
                                                              attrs: {
                                                                value:
                                                                  permission.name,
                                                                disabled: "",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { md: "6" } },
                                    [
                                      _c("span", { staticClass: "font-bold" }, [
                                        _vm._v("Assigned Permissions"),
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.assignedAdminPermissions,
                                        function (permissionsGroup, key) {
                                          return _c(
                                            "div",
                                            {
                                              key: key,
                                              staticClass:
                                                "permission-group my-2",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "font-medium text-uppercase d-flex items-center justify-content-between cursor-pointer permission-group-header",
                                                  on: {
                                                    click: () =>
                                                      _vm.togglePermissionGroup(
                                                        "assigned",
                                                        permissionsGroup.group
                                                      ),
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        permissionsGroup.group.replaceAll(
                                                          "_",
                                                          " "
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  typeof _vm
                                                    .visiblePermissionGroups
                                                    .assigned[
                                                    permissionsGroup.group
                                                  ] !== "undefined"
                                                    ? _c("b-icon-chevron-up")
                                                    : _c("b-icon-chevron-down"),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-collapse",
                                                {
                                                  attrs: {
                                                    visible:
                                                      typeof _vm
                                                        .visiblePermissionGroups
                                                        .assigned[
                                                        permissionsGroup.group
                                                      ] !== "undefined",
                                                  },
                                                },
                                                _vm._l(
                                                  permissionsGroup.permissions,
                                                  function (permission, index) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: index,
                                                        staticClass: "pt-2",
                                                      },
                                                      [
                                                        _c(
                                                          "b-input-group",
                                                          {
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "append",
                                                                  fn: function () {
                                                                    return [
                                                                      _c(
                                                                        "b-button",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              variant:
                                                                                "danger",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.removeAdminPermission(
                                                                                  permission
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Remove"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                  proxy: true,
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("b-input", {
                                                              attrs: {
                                                                value:
                                                                  permission.name,
                                                                disabled: "",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "no-permission-wrapper",
                            { attrs: { show: !_vm.canUpdateUsers } },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    type: "submit",
                                    variant: "primary",
                                    disabled:
                                      _vm.adminAccessFormState.processing ||
                                      !_vm.canUpdateUsers,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              Update user Admin Access\n              "
                                  ),
                                  _vm.adminAccessFormState.processing
                                    ? _c("b-spinner", {
                                        staticClass: "ml-1",
                                        attrs: { small: "" },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("admin-user-auth-token-modal", {
        ref: "authTokenModal",
        attrs: { "user-id": parseInt(_vm.id) },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }